import { Response } from '@angular/http';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/of';
import { EqualiserBar, Tuple, Tuple3 } from '../../entities';
import { InterpretationOverviewModel, SystemModel, QuoteOverviewModel, RecommendationModel, UpdateComponentPhotoModel, AddComponentPhotoModel, AuditModel, UpdateConditionPhotoModel, UpdateConditionCommentModel, Condition, RecommendationTypeModel, AddRecommendationModel, UpdateRecommendationModel, SystemGraphModel, Recipient, UpdateComponentMeasurementModel, AvailableInspectorsViewModel, UpdateInspectionReadingBasedOnMeasurementClassModel, UpdateInspectionForwardAndReverseTravelModel, EquipmentModel, UpdateUnderFootConditionModel, UpdateFlag, AddThermalPhotoModel, ComponentImageListVm, ComponentModel, SendQuoteReportVM, SeverityTypeModel, ComponentFlaggedVM, TRACK_FORECAST, TRACKForcastVM, AddRecommendationVM, CopyInspection, CopyInspectionResponse, ParentInspectionResponse, UpdateComponenMultipletMeasurementModel, ActionRecommentDationOnDateVM, ComponentImagesResponse, ForecastConfigurationVM, ForecastWearConfigurationViewModel, ForecastWearConfigurationComponentViewModel, ForecastingComponentWearRateGroupViewModel, UpdateAvgCmu, InspectionMeasurement, InspectionMeasurementVM, AddiInspectorsOverviewModel, QuoteContactViewModel, SystemInspectionImagesModel, SystemInspectionImagesVM, EqualiserBarMeasurementUpdateModel, InspectionLocationVM } from './models/interpretation.model';
import { AppService } from '../../app.service';
import { catchError } from 'rxjs/operators';
import { UpdateEvalModel, UpdateObservationListPhotoModel } from './interpretation.model';
import { InspectionAdditionalObservationImagesVM, InspectionAdditionalObservationListsViewModel } from '../inspection/models/create-inspection.model';
import { InspectionTypeVM } from '../rope-shovel/models/rope-shovel.model';
import { AnswersOptionsVM } from '../Training/setup-training-types.model';
import { GenericIdName } from '../GET_NEW_UI/setup-implement/setup-implement.model';
import { AddUpdateWorkOrder, BogieCommentVM, BogieImageModel, BogieImageVM } from '../../shared/components/bogie-shim/bogie-shim-model';
import { UnitNumberVm } from '../setup-models/setup-models.model';
import { ImageVM } from '../inventory/inventory-models';
import { ForecastSeason, ForecastSeasonSaveRequest } from './models/Forecast.model';
import { ComponentImagesHistory } from '../../shared/components/component-image-history/component-image-history.model';

@Injectable()
export class InterpretationService {
  private userId = 1;

  constructor(private _http: HttpClient,
    private _app: AppService) {
    this.getUserId().subscribe(r => this.userId = r, err => console.error(err));
  }

  public checkPermission(inspectionId: number): Observable<Tuple> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString())
    };
    return this._http.get<Tuple>('api/interpretation/CheckPermission', options).pipe(catchError(this.handleError));
  }

  // public sendPdfReport(quoteId: number, emailList: string[], oldUcUrl: string, includeQuoteReport: boolean, userNames:string[]) {
  //   let params: HttpParams = new HttpParams();
  //   let contactInfo: string = '';
  //   for (let i = 0; i < emailList.length; i++) {
  //     contactInfo = contactInfo + emailList[i] + ' (' + emailList[i] + ')';
  //     if (emailList.length - 1 != i)
  //       contactInfo = contactInfo + ',';
  //   }
  //   let payload = {
  //     conatctInformation: contactInfo,
  //     quoteAuto: quoteId,
  //     userAuto: this.userId,
  //     sendQuote: includeQuoteReport,
  //   };

  //   return this._http.post(oldUcUrl + "track/TrackInspectionInterpretation.aspx/btnSendReport_Click", payload).pipe(catchError(this.handleError));
  // }

  public sendPdfReportWithNewParams(quoteId: number, emailList: string[], oldUcUrl: string, includeQuoteReport: boolean, userNames: string[], sendTemperature: boolean, SendImmediately: boolean): Observable<any> {
    const payload: QuoteContactViewModel = {
      ContactInformations: emailList,
      QuoteAuto: quoteId,
      UserAuto: this.userId,
      SendQuote: includeQuoteReport,
      UserNames: userNames,
      SendTemperature: sendTemperature,
      SendReportImmediately: SendImmediately
    };

    return this._http
      .post<any>("api/interpretation/SendInterpretationReport", payload)
      .pipe(catchError(this.handleError));

    // return this._http.post(oldUcUrl + 'track/TrackInspectionInterpretation.aspx/SentReportWithName', payload)
    //   .pipe(catchError(this.handleError));
  }

  public SendQuoteReport(quoteInfo: SendQuoteReportVM): Observable<boolean> {

    return this._http.post<boolean>("api/interpretation/SendQuoteReport", quoteInfo).pipe(catchError(this.handleError));
  }

  public getUserId(): Observable<number> {
    return this._http.get<number>('api/interpretation/GetUserId').pipe(catchError(this.handleError));
  }

  public getRecipientList(inspectionId: number, equipment_id: number, InspectorName: string): Observable<Recipient[]> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString()).set('equipment_id', equipment_id.toString()).set('InspectorName', InspectorName.toString())
    };
    return this._http.get<Recipient[]>('api/interpretation/GetRecipientList', options).pipe(catchError(this.handleError));
  }

  public getOverallEval(inspectionId: number): Observable<string> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString())
    };
    return this._http.get<string>('api/interpretation/getoveralleval', options).pipe(catchError(this.handleError));
  }

  public setOverallEval(updateModel: UpdateEvalModel): Observable<Tuple> {
    // let options = {
    //   params: new HttpParams().set('inspectionId', inspectionId.toString()).set('newEval', newEval)
    // };
    // return this._http.post<UpdateEvalModel>('api/interpretation/setoveralleval', updateModel).pipe(catchError(this.handleError));
    return this._http.post<Tuple>('api/interpretation/setoveralleval', updateModel).pipe(catchError(this.handleError));
  }

  public getInterpretationOverview(inspectionId: number): Observable<InterpretationOverviewModel> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString())
    };
    return this._http.get<InterpretationOverviewModel>('api/interpretation/getinterpretationoverview', options).pipe(catchError(this.handleError));
  }

  public getInterpretationSelectedQuoteId(inspectionId: number): Observable<number> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString())
    };
    return this._http.get<number>('api/interpretation/GetInterpretationSelectedQuoteId', options).pipe(catchError(this.handleError));
  }

  public changeInspectionsInspector(inspectionId: number, userId: number) {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString()).set('userId', userId.toString())
    };
    return this._http.get('api/interpretation/ChangeInspectionInspector', options).pipe(catchError(this.handleError));
  }

  public checkTrackFrameFlag(inspectionId: number): Observable<boolean> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString())
    };
    return this._http.get<boolean>('api/interpretation/CheckTrackFrameIncorrect', options).pipe(catchError(this.handleError));
  }


  public getOverallInterpretationComment(inspectionId: number): Observable<string> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString())
    };
    return this._http.get<string>('api/interpretation/getoverallinterpretationcomment', options).pipe(catchError(this.handleError));
  }


  public UpdateTrackFrameFlag(inspectionId: number): Observable<boolean> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString())
    };
    return this._http.get<boolean>('api/interpretation/updateTrackFrameConfigFlag', options).pipe(catchError(this.handleError));
  }

  public setOverallInterpretationComment(inspectionId: number, newComment: string): Observable<Tuple> {
    const body = {
      inspectionId: inspectionId,
      newComment: newComment
    };
    return this._http.post<Tuple>('api/interpretation/setoverallinterpretationcomment', body).pipe(catchError(this.handleError));
  }

  public getSystemIds(inspectionId: number): Observable<number[]> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString())
    };
    return this._http.get<any>('api/interpretation/getsystemids', options).pipe(catchError(this.handleError));
  }

  public getSystemIdsForecast(inspectionId: number): Observable<number[]> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString())
    };
    return this._http.get<any>('api/interpretation/getsystemidsForecast', options).pipe(catchError(this.handleError));
  }

  public getSystem(inspectionId: number, systemId: number): Observable<SystemModel> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString()).set('systemId', systemId.toString())
    };
    return this._http.get<SystemModel>('api/interpretation/getsystem', options).pipe(catchError(this.handleError));
  }

  public UpdateComponentMeasurementRefreshInperp(_InspectionMeasurement: InspectionMeasurementVM): Observable<boolean> {

    return this._http.post<boolean>('api/interpretation/UpdateComponentMeasurementRefreshInperp', _InspectionMeasurement).pipe(catchError(this.handleError));
  }

  //InspectionReport
  public getInspectionreportingDetail(inspectionId: number): Observable<ComponentModel[]> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString())
    };
    return this._http.get<ComponentModel[]>('api/interpretation/getInspectionreportingDetail', options).pipe(catchError(this.handleError));
  }

  public getSystemGraph(inspectionId: number, systemId: number): Observable<SystemGraphModel> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString()).set('systemId', systemId.toString())
    };
    return this._http.get<SystemGraphModel>('api/interpretation/getsystemgraph', options).pipe(catchError(this.handleError));
  }

  public getQuoteOverviews(inspectionId: number): Observable<QuoteOverviewModel[]> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString())
    };
    return this._http.get<QuoteOverviewModel[]>('api/interpretation/getquoteoverviews', options).pipe(catchError(this.handleError));
  }

  public getRecommendation(inspectionId: number, recommendationId: number): Observable<RecommendationModel> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString()).set('recommendationId', recommendationId.toString())
    };
    return this._http.get<RecommendationModel>('api/interpretation/getrecommendation', options).pipe(catchError(this.handleError));
  }

  public getComponentPhoto(inspectionId: number, photoId: number): Observable<string> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString()).set('photoId', photoId.toString())
    };
    return this._http.get<string>('api/interpretation/getcomponentphoto', options).pipe(catchError(this.handleError));
  }

  public getComponentPhotoList(inspectionDetailId: number, inspectionId: number): Observable<ComponentImageListVm> {
    const options = {
      params: new HttpParams().set('inspectionDetailId', inspectionDetailId.toString()).set('inspectionId', inspectionId.toString())
    };
    return this._http.get<ComponentImageListVm>('api/interpretation/getcomponentphotoList', options).pipe(catchError(this.handleError));
  }

  public getEquipmentPhoto(equipmentId: number): Observable<Tuple> {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString())
    };
    return this._http.get<Tuple>('api/ManageEquipment/GetEquipmentPhoto', options).pipe(catchError(this.handleError));
  }

  public getInspectionEquipmentPhoto(InspectionId: number): Observable<Tuple> {
    const options = {
      params: new HttpParams().set('InspectionId', InspectionId.toString())
    };
    return this._http.get<Tuple>('api/ManageEquipment/GetEquipmentInspectionPhoto', options).pipe(catchError(this.handleError));
  }

  public getConditionPhoto(inspectionId: number, condition: Condition): Observable<string> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString()).set('condition', condition.toString())
    };
    return this._http.get<string>('api/interpretation/getconditionphoto', options).pipe(catchError(this.handleError));
  }

  public getThermalPhoto(inspectionId: number, side: number, photoId: number): Observable<string> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString()).set('side', side.toString()).set('photoId', photoId.toString())
    };
    return this._http.get<string>('api/interpretation/getThermalnphoto', options).pipe(catchError(this.handleError));
  }

  public getSmuHrsPhoto(inspectionId: number): Observable<string> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString())
    };
    return this._http.get<string>('api/interpretation/getSmuHrsPhoto', options).pipe(catchError(this.handleError));
  }


  public GetUserPreferences(): Observable<string> {
    return this._http.get<string>('api/inspection/GetUserPreferences').pipe(catchError(this.handleError));
  }
  public GetUserPreferencesDistance(): Observable<string> {
    return this._http.get<string>('api/inspection/GetUserPreferencesDistance').pipe(catchError(this.handleError));
  }

  public GetUserPreferenceUCConditon(): Observable<string> {
    return this._http.get<string>('api/inspection/GetUserPreferenceUCConditon').pipe(catchError(this.handleError));
  }

  public getInspectionDraftConditionPhoto(inspectionDraftId: number, condition: Condition, equipmentId: number): Observable<string> {
    const options = {
      params: new HttpParams()
        .set('inspectionDraftId', inspectionDraftId.toString())
        .set('condition', condition.toString())
        .set('equipmentId', equipmentId.toString())
    };
    return this._http.get<string>('api/inspection/GetInspectionDraftPhoto', options).pipe(catchError(this.handleError));
  }

  public deleteDraftConditionPhoto(inspectionDraftId: number, condition: Condition, equipmentId: number): Observable<boolean> {
    const options = {
      params: new HttpParams()
        .set('inspectionDraftId', inspectionDraftId.toString())
        .set('condition', condition.toString())
        .set('equipmentId', equipmentId.toString())
    };
    return this._http.get<boolean>('api/inspection/DeleteDraftConditionPhoto', options).pipe(catchError(this.handleError));
  }


  deleteInspectionDetailPhoto(inspectionDetailId: number, equipmentId: number, photoId: number): Observable<boolean> {
    const options = {
      params: new HttpParams()
        .set('inspectionDetailDraftId', inspectionDetailId.toString())
        .set('equipmentId', equipmentId.toString())
        .set('photoId', photoId.toString())
    };
    return this._http.get<boolean>('api/inspection/DeleteInspectionDetailPhoto', options).pipe(catchError(this.handleError));
  }



  public getInspectionDetailPhoto(inspectionDetailId: number, equipmentId: number, photoId: number): Observable<string> {
    const options = {
      params: new HttpParams()
        .set('inspectionDetailId', inspectionDetailId.toString())
        .set('equipmentId', equipmentId.toString())
        .set('photoId', photoId.toString())
    };
    return this._http.get<string>('api/inspection/GetInspectionDetailPhoto', options).pipe(catchError(this.handleError));
  }
  public getInspectionDetailPhotoList(inspectionDetailId: number, equipmentId: number, photoId: number): Observable<ComponentImageListVm> {
    const options = {
      params: new HttpParams()
        .set('inspectionDetailId', inspectionDetailId.toString())
        .set('equipmentId', equipmentId.toString())
        .set('photoId', photoId.toString())
    };
    return this._http.get<ComponentImageListVm>('api/inspection/GetInspectionDetailPhotoList', options).pipe(catchError(this.handleError));
  }

  public getAvailableInspectorsBasedOnEquipment(equipmentId: number): Observable<AvailableInspectorsViewModel[]> {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString())
    };
    console.log("equipmentId", equipmentId)
    return this._http.get<AvailableInspectorsViewModel[]>('api/interpretation/GetAllInspectorsThatCanInspectThisEquipment', options).pipe(catchError(this.handleError));
  }
  public getInspectionTypes(modelId: number): Observable<InspectionTypeVM[]> {
    const options = {
      params: new HttpParams().set('modelId', modelId.toString())
    };
    console.log("modelId", modelId)
    return this._http.get<InspectionTypeVM[]>('api/RopeShovelInspection/GetAllInspectionTypes', options).pipe(catchError(this.handleError));
  }

  public UpdateRSHInspectionType(inspectionId: number, inspectionTypeId: number): Observable<Tuple> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString()).set('inspectionTypeId', inspectionTypeId.toString())
    };
    return this._http.get<Tuple>('api/RopeShovelInspection/UpdateRSHInspectionType', options).pipe(catchError(this.handleError));
  }
  public updateComponentPhotoTitle(photo: UpdateComponentPhotoModel): Observable<Tuple> {
    return this._http.post<Tuple>('api/interpretation/UpdateComponentPhotoTitle', photo).pipe(catchError(this.handleError));
  }

  public updateComponentPhotoTitle_Inspection(photo: UpdateComponentPhotoModel): Observable<Tuple> {
    return this._http.post<Tuple>('api/inspection/UpdateComponentPhotoTitle', photo).pipe(catchError(this.handleError));
  }
  public updateComponentPhoto(photo: UpdateComponentPhotoModel): Observable<Tuple> {
    return this._http.post<Tuple>('api/interpretation/UpdateComponentPhoto', photo).pipe(catchError(this.handleError));
  }

  public updateComponentPhoto_New(photo: UpdateComponentPhotoModel): Observable<Tuple> {
    return this._http.post<Tuple>('api/interpretation/UpdateComponentPhotoNew', photo).pipe(catchError(this.handleError));
  }

  public updateComponentPhotoOnInspectionDraft(photo: UpdateComponentPhotoModel): Observable<Tuple> {
    return this._http.post<Tuple>('api/inspection/UpdateComponentPhoto_New', photo).pipe(catchError(this.handleError));
  }

  public updateComponentMeasurement(m: UpdateComponentMeasurementModel): Observable<Tuple> {
    return this._http.post<Tuple>('api/interpretation/UpdateComponentMeasurement', m).pipe(catchError(this.handleError));
  }

  public updateComponentMultipleMeasurement(m: UpdateComponenMultipletMeasurementModel): Observable<Tuple> {
    return this._http.post<Tuple>('api/interpretation/UpdateComponentMultipleMeasurement', m).pipe(catchError(this.handleError));
  }
  public GetComponentMeasurement(inspectionId: number, inspectionDetailId: number): Observable<ComponentModel> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString()).set('inspectionDetailId', inspectionDetailId.toString())
    };
    return this._http.get<ComponentModel>('api/interpretation/GetComponentMeasurement', options).pipe(catchError(this.handleError));
  }
  public updateEquipmentPhoto(photo: UpdateComponentPhotoModel): Observable<Tuple> {
    return this._http.post<Tuple>('api/ManageEquipment/UpdateEquipmentPhoto', photo).pipe(catchError(this.handleError));
  }

  public updateConditionPhoto(photo: UpdateConditionPhotoModel): Observable<Tuple> {
    return this._http.post<Tuple>('api/interpretation/UpdateConditionPhoto', photo).pipe(catchError(this.handleError));
  }

  public updateThermalPhoto(photo: AddThermalPhotoModel): Observable<Tuple> {
    return this._http.post<Tuple>('api/interpretation/UpdateThermalPhoto', photo).pipe(catchError(this.handleError));
  }
  public updateInspectionDraftConditionPhoto(photo: UpdateConditionPhotoModel): Observable<Tuple> {
    return this._http.post<Tuple>('api/inspection/UpdateConditionPhoto', photo).pipe(catchError(this.handleError));
  }

  public updateConditionComment(comment: UpdateConditionCommentModel): Observable<Tuple> {
    return this._http.post<Tuple>('api/interpretation/UpdateConditionComment', comment).pipe(catchError(this.handleError));
  }

  public updateInspectionDraftConditionComment(comment: UpdateConditionCommentModel): Observable<Tuple> {
    return this._http.post<Tuple>('api/inspection/UpdateConditionComment', comment).pipe(catchError(this.handleError));
  }

  public addComponentPhoto(photo: AddComponentPhotoModel): Observable<Tuple> {
    return this._http.post<Tuple>('api/interpretation/AddComponentPhoto', photo).pipe(catchError(this.handleError));
  }

  public addInspectionComponentPhotoDraft(photo: AddComponentPhotoModel): Observable<Tuple> {
    return this._http.post<Tuple>('api/inspection/AddComponentPhoto', photo).pipe(catchError(this.handleError));
  }
  public addInspectionComponentPhoto(photo: AddComponentPhotoModel): Observable<BogieImageModel> {
    return this._http.post<BogieImageModel>('api/inspection/AddComponentPhotoPath', photo).pipe(catchError(this.handleError));
  }

  public addInspectionThermalImage(photo: AddThermalPhotoModel): Observable<Tuple> {
    return this._http.post<Tuple>('api/interpretation/AddThermalPhoto', photo).pipe(catchError(this.handleError));
  }

  public deleteComponentPhoto(inspectionId: number, photoId: number, screenId: number = 0): Observable<Tuple> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString()).set('photoId', photoId.toString()).set('screenId', screenId.toString())
    };
    return this._http.delete<Tuple>('api/interpretation/DeleteComponentPhoto', options).pipe(catchError(this.handleError));
  }

  public deleteEquipmentPhoto(equipmentId: number): Observable<Tuple> {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString())
    };
    return this._http.delete<Tuple>('api/ManageEquipment/DeleteEquipmentPhoto', options).pipe(catchError(this.handleError));
  }

  public deleteConditionPhoto(inspectionId: number, condition: Condition): Observable<Tuple> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString()).set('condition', condition.toString())
    };
    return this._http.delete<Tuple>('api/interpretation/DeleteConditionPhoto', options).pipe(catchError(this.handleError));
  }
  public deleteThermalPhoto(inspectionId: number, side: number, photoId: number): Observable<Tuple> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString()).set('side', side.toString()).set('photoId', photoId.toString())
    };
    return this._http.delete<Tuple>('api/interpretation/DeleteThermalPhoto', options).pipe(catchError(this.handleError));
  }

  public deleteSmuHourPhoto(inspectionId: number): Observable<Tuple> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString())
    };
    return this._http.delete<Tuple>('api/interpretation/deleteSmuHourPhoto', options).pipe(catchError(this.handleError));
  }



  public updateComponentComment(inspectionId: number, inspectionDetailId: number, newComment: string, updateInspectionComment: boolean = false, screenId: number = 0): Observable<Tuple> {
    const options = {
      params: new HttpParams()
        .set('inspectionId', inspectionId.toString())
        .set('inspectionDetailId', inspectionDetailId.toString())
        .set('newComment', newComment)
        .set('updateInspectionComment', updateInspectionComment.toString())
        .set('screenId', screenId.toString())
    };
    return this._http.get<Tuple>('api/interpretation/updatecomponentcomment', options).pipe(catchError(this.handleError));
  }

  public GetComponentTypeComments(compartTypeId: number, inspectionId: number): Observable<GenericIdName[]> {
    const options = {
      params: new HttpParams().set('compartTypeId', compartTypeId.toString()).set('inspectionId', inspectionId.toString())
    };
    return this._http.get<GenericIdName[]>('api/interpretation/GetComponentTypeComments', options).pipe(catchError(this.handleError));
  }
  public GetComponentComment(inspectionId: number, inspectionDetailId: number): Observable<Tuple> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString()).set('inspectionDetailId', inspectionDetailId.toString())
    };
    return this._http.get<Tuple>('api/interpretation/GetComponentComment', options).pipe(catchError(this.handleError));
  }
  public getAuditLog(inspectionId: number): Observable<AuditModel[]> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString())
    };
    return this._http.get<AuditModel[]>('api/interpretation/getauditlog', options).pipe(catchError(this.handleError));
  }

  public getPossibleRecommendations(inspectionId: number, componentId: number): Observable<RecommendationTypeModel[]> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString()).set('componentId', componentId.toString())
    };
    return this._http.get<RecommendationTypeModel[]>('api/interpretation/GetPossibleRecommendations', options).pipe(catchError(this.handleError));
  }

  public getSeverityDropdown(inspectionId: number): Observable<SeverityTypeModel[]> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString())
    };
    return this._http.get<SeverityTypeModel[]>('api/interpretation/GetSeverity', options).pipe(catchError(this.handleError));
  }

  public releaseReport(inspectionId: number, quoteId: number): Observable<Tuple> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString()).set('quoteId', quoteId.toString())
    };
    return this._http.get<Tuple>('api/interpretation/ReleaseReport', options).pipe(catchError(this.handleError));
  }

  public addQuote(inspectionId: number): Observable<Tuple> {
    return this._http.post<Tuple>('api/interpretation/AddQuote?inspectionId=' + inspectionId, inspectionId).pipe(catchError(this.handleError));
  }

  public addRecommendation(recommendation: AddRecommendationModel): Observable<Tuple3> {
    return this._http.post<Tuple3>('api/interpretation/AddRecommendation', recommendation).pipe(catchError(this.handleError));
  }

  public updateRecommendation(recommendation: UpdateRecommendationModel): Observable<Tuple> {
    return this._http.post<Tuple>('api/interpretation/UpdateRecommendation', recommendation).pipe(catchError(this.handleError));
  }

  public deleteRecommendation(inspectionId: number, recommendationId: number): Observable<Tuple> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString()).set('recommendationId', recommendationId.toString())
    };
    return this._http.delete<Tuple>('api/interpretation/DeleteRecommendation', options).pipe(catchError(this.handleError));
  }


  public UpdateInspectionReadingBasedOnMeasurementClass(newReading: number, condition: Condition, inspectionId: number): Observable<Tuple> {
    const model = new UpdateInspectionReadingBasedOnMeasurementClassModel();
    model.InspectionId = inspectionId;
    model.Condition = condition;
    model.Reading = newReading;
    return this._http.post<Tuple>('api/interpretation/UpdateInspectionReadingBasedOnMeasurementClass', model).pipe(catchError(this.handleError));
  }


  public UpdateForwardAndReverseReading(model: UpdateInspectionForwardAndReverseTravelModel): Observable<Tuple> {
    return this._http.post<Tuple>('api/interpretation/UpdateForwardAndReverseReading', model).pipe(catchError(this.handleError));
  }
  public updateInspectionComment(inspectionId: number, newComment: string): Observable<Tuple> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString()).set('newComment', newComment)
    };
    return this._http.get<Tuple>('api/interpretation/SetOverallInspectionComment', options).pipe(catchError(this.handleError));
  }

  public updateJobsiteComment(inspectionId: number, newComment: string): Observable<Tuple> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString()).set('newComment', newComment)
    };
    return this._http.get<Tuple>('api/interpretation/SetOverallJobsitenComment', options).pipe(catchError(this.handleError));
  }



  public UpdateInspectionObservationListPhoto(inspectionObId: number, photoData: string, photoId: number): Observable<Tuple> {
    const model = new UpdateObservationListPhotoModel(inspectionObId, photoData, photoId);
    return this._http.post<Tuple>('api/inspection/UpdateInspectionObservationListPhoto', model).pipe(catchError(this.handleError));
  }

  public updateInspectionSMUPhoto(inspectionId: number, photoData: string): Observable<Tuple> {
    let model = { inspectionId: inspectionId, newPhoto: photoData }
    return this._http.post<Tuple>('api/inspection/UpdateSmuPhoto', model).pipe(catchError(this.handleError));
  }



  public smuPhoto(inspectionObId: number, photoData: string, photoId: number): Observable<Tuple> {
    const model = new UpdateObservationListPhotoModel(inspectionObId, photoData, photoId);
    return this._http.post<Tuple>('api/inspection/UpdateInspectionObservationListPhoto', model).pipe(catchError(this.handleError));
  }


  public GetObservationListDraftPhoto(obDraftId: number, PhotoId: number): Observable<string> {
    const options = {
      params: new HttpParams().set('obDraftId', obDraftId.toString()).set('PhotoId', PhotoId.toString())
    };
    return this._http.get<string>('api/inspection/GetObservationListDraftPhoto', options).pipe(catchError(this.handleError));
  }

  public GetSystemImages(inspectionId: number, SystemId: number): Observable<SystemInspectionImagesVM> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString()).set('systemId', SystemId.toString())
    };
    return this._http.get<SystemInspectionImagesVM>('api/inspection/GetSystemImages', options).pipe(catchError(this.handleError));
  }


  public UpdateInspectionObservationListComment(inspectionObId: number, newComment: string) {
    const options = {
      params: new HttpParams().set('inspectionObId', inspectionObId.toString()).set('comment', newComment)
    };
    return this._http.get('api/inspection/UpdateInspectionObservationListComment', options).pipe(catchError(this.handleError));
  }


  public UpdateInspectionAdditionalObsAnswer(model: AnswersOptionsVM[]): Observable<boolean> {
    return this._http.post<boolean>('api/inspection/UpdateInspectionAdditionalObsAnswer', model).pipe(catchError(this.handleError));
  }



  public UpdateEquipmentComment(equipmentId: number, newComment: string) {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString()).set('comment', newComment)
    };
    return this._http.get('api/ManageEquipment/UpdateEquipmentComment', options).pipe(catchError(this.handleError));
  }


  public UpdateEquipmentDetailComment(inspectionObId: number, newComment: string) {
    const options = {
      params: new HttpParams().set('inspectionObId', inspectionObId.toString()).set('comment', newComment)
    };
    return this._http.get('api/inspection/UpdateInspectionObservationListComment', options).pipe(catchError(this.handleError));
  }


  public DeleteInspectionObservationListPhoto(inspectionObId: number, PhotoId: number) {
    const options = {
      params: new HttpParams().set('inspectionObId', inspectionObId.toString()).set('PhotoId', PhotoId.toString())
    };
    return this._http.get('api/inspection/DeleteInspectionObservationListPhoto', options).pipe(catchError(this.handleError));
  }


  public UpdateObservationListDraftPhoto(obDraftId: number, photoData: string, PhotoId: number): Observable<Tuple> {
    // const options = {
    //   params: new HttpParams().set('obDraftId', obDraftId.toString()).set('photoData', photoData)
    // };
    const model = new UpdateObservationListPhotoModel(obDraftId, photoData, PhotoId);
    return this._http.post<Tuple>('api/inspection/UpdateObservationListDraftPhoto', model).pipe(catchError(this.handleError));
  }



  public UpdateObservationListDraftAnswer(model: AnswersOptionsVM[]): Observable<Tuple> {
    return this._http.post<Tuple>('api/inspection/UpdateObservationListDraftAnswer', model).pipe(catchError(this.handleError));
  }


  public UpdateObservationListDraftComment(obDraftId: number, newComment: string): Observable<number> {
    const options = {
      params: new HttpParams().set('obDraftId', obDraftId.toString()).set('comment', newComment)
    };
    return this._http.get<number>('api/inspection/UpdateObservationListDraftComment', options).pipe(catchError(this.handleError));
  }


  public DeleteObservationListDraftPhoto(obDraftId: number, PhotoId: number) {
    const options = {
      params: new HttpParams().set('obDraftId', obDraftId.toString()).set('PhotoId', PhotoId.toString())
    };
    return this._http.get('api/inspection/DeleteObservationListDraftPhoto', options).pipe(catchError(this.handleError));
  }




  public GetAllAdditionalObservationLists(inspectionId: number): Observable<InspectionAdditionalObservationListsViewModel[]> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString())
    };
    return this._http.get<InspectionAdditionalObservationListsViewModel[]>('api/interpretation/GetAllAdditionalObservationLists', options).pipe(catchError(this.handleError));
  }

  public GetInspectionObservationListComment(inspectionObId: number): Observable<string> {
    const options = {
      params: new HttpParams().set('inspectionObId', inspectionObId.toString())
    };
    return this._http.get<string>('api/Inspection/GetInspectionObservationListComment', options).pipe(catchError(this.handleError));
  }
  public GetInspectionObservationListImage(inspectionObId: number, PhotoId: number): Observable<string> {
    const options = {
      params: new HttpParams().set('inspectionObId', inspectionObId.toString()).set('PhotoId', PhotoId.toString())
    };
    return this._http.get<string>('api/Inspection/GetInspectionObservationListPhoto', options).pipe(catchError(this.handleError));
  }

  public GetInspectionObservationListImageList(inspectionObId: number): Observable<InspectionAdditionalObservationImagesVM[]> {
    const options = {
      params: new HttpParams().set('inspectionObId', inspectionObId.toString())
    };
    return this._http.get<InspectionAdditionalObservationImagesVM[]>('api/Inspection/GetInspectionObservationListImageList', options).pipe(catchError(this.handleError));
  }


  public DeleteAdditionalObsPoint(inspectionId: number, ObsId: number): Observable<Tuple> {
    const options = {
      params: new HttpParams().set('ObsId', ObsId.toString()).set('inspectionId', inspectionId.toString())
    };
    return this._http.get<Tuple>('api/interpretation/DeleteAdditionalObs', options).pipe(catchError(this.handleError));
  }

  public EditAdditionalObsPoint(inspectionId: number, ObsId: number, title: string): Observable<Tuple> {
    const options = {
      params: new HttpParams().set('ObsId', ObsId.toString()).set('inspectionId', inspectionId.toString()).set('title', title)
    };
    return this._http.get<Tuple>('api/interpretation/EditAdditionalObs', options).pipe(catchError(this.handleError));
  }
  public UpdateSystemSerialNumber(SerialNumber: string, systemId: number): Observable<Tuple> {
    const options = {
      params: new HttpParams().set('SerialNumber', SerialNumber.toString()).set('systemId', systemId.toString())
    };
    return this._http.get<Tuple>('api/UCSystem/EditSystemSerialNumber', options).pipe(catchError(this.handleError));
  }

  public GetSystemSerial(systemId: number): Observable<string> {
    const options = {
      params: new HttpParams().set('systemId', systemId.toString())
    };
    return this._http.get<string>('api/UCSystem/GetSystemSerial', options).pipe(catchError(this.handleError));
  }


  public UpdateUnderFootConditions(model: UpdateUnderFootConditionModel): Observable<Tuple> {
    return this._http.post<Tuple>('api/interpretation/UpdateUnderFootConditions', model).pipe(catchError(this.handleError));
  }


  public UpdateComponentFlaggedInfo(model: ComponentFlaggedVM): Observable<Tuple> {
    return this._http.post<Tuple>('api/interpretation/UpdateComponentFlaggedInfo', model).pipe(catchError(this.handleError));
  }



  public updateComponentFlag(inspectionId: number, selected_inspection_detail_auto: number, selected_track_unit_auto: number): Observable<boolean> {

    const model = new UpdateFlag();
    model.inspectionId = inspectionId;
    model.selected_inspection_detail_auto = selected_inspection_detail_auto;
    model.selected_track_unit_auto = selected_track_unit_auto;
    return this._http.post<boolean>('api/interpretation/updateComponentFlag', model).pipe(catchError(this.handleError));
  }

  public SendHireReport(id: number, id2: number, emailAddress: string, customerName: string): Observable<boolean> {
    let options = {
      params: new HttpParams().set('id', id.toString()).set('id2', id2.toString()).set('emailAddress', emailAddress).set('customerName', customerName)

    };
    return this._http.get<boolean>("api/RentalInterp/SendReport_", options).pipe(catchError(this.handleError));
  }


  public getFlaggedComponentInfo(inspectionId: number): Observable<ComponentFlaggedVM[]> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString())
    };
    return this._http.get<ComponentFlaggedVM[]>('api/interpretation/getFlaggedComponentInfo', options).pipe(catchError(this.handleError));
  }

  public setFlaggedComponentActionTaken(inspectionId: number, flaggedComponentId: number, removeFromActionTaken: boolean, actionTaken: boolean): Observable<boolean> {
    const options = {
      params: new HttpParams().set('InspectionId', inspectionId.toString())
        .set('FlaggedComponentId', flaggedComponentId.toString())
        .set('RemoveFromActionTaken', removeFromActionTaken.toString())
        .set('ActionTaken', actionTaken.toString())
    };
    return this._http.get<boolean>('api/interpretation/SetFlaggedComponentActionTaken', options).pipe(catchError(this.handleError));
  }
  public getDailyUsageHoursAndDistance(inspectionId: number): Observable<any> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString())
    };
    return this._http.get('api/interpretation/GetDailyUsageHoursAndDistance', options).pipe(catchError(this.handleError));
  }
  public SaveForeCastData(data: TRACKForcastVM): Observable<any> {
    return this._http.post('api/interpretation/SaveDailyUsageForecastData', data).pipe(catchError(this.handleError));
  }

  private handleError(error: Response) {
    return Observable.throw(error || 'Server error');
  }

  public getSystemData(inspectionId: number, systemId: number, date: string): Observable<SystemModel> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString()).set('systemId', systemId.toString()).set('todayDate', date.toString())
    };
    return this._http.get<SystemModel>('api/interpretation/getsystemdata', options).pipe(catchError(this.handleError));
  }

  public ForecastTrackReset(inspectionId: number): Observable<any> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString())
    };
    return this._http.get('api/interpretation/ForecastTrackReset', options).pipe(catchError(this.handleError));
  }

  public UpdateBudgetLife(systemId: number, newValue: number, screenId: number): Observable<boolean> {
    const options = {
      params: new HttpParams().set('SystemId', systemId.toString()).set('NewValue', newValue.toString()).set('ScreenId', screenId?.toString())
    };
    return this._http.get<boolean>('api/UCSystem/UpdateBudgetLife', options).pipe(catchError(this.handleError));
  }
  public UpdateFrameCost(systemId: number, newValue: number, screenId: number): Observable<boolean> {
    const options = {
      params: new HttpParams().set('SystemId', systemId.toString()).set('NewValue', newValue.toString()).set('ScreenId', screenId?.toString())
    };
    return this._http.get<boolean>('api/UCSystem/UpdateFrameCost', options).pipe(catchError(this.handleError));
  }

  public UpdateFrameRepairCost(systemId: number, newValue: number, screenId: number): Observable<boolean> {
    const options = {
      params: new HttpParams().set('SystemId', systemId.toString()).set('NewValue', newValue.toString()).set('ScreenId', screenId.toString())
    };
    return this._http.get<boolean>('api/UCSystem/UpdateFrameRepairCost', options).pipe(catchError(this.handleError));
  }
  public UpdateBudgetDistance(systemId: number, newValue: number, screenId: number): Observable<boolean> {
    const options = {
      params: new HttpParams().set('SystemId', systemId.toString()).set('NewValue', newValue.toString()).set('ScreenId', screenId?.toString())
    };
    return this._http.get<boolean>('api/UCSystem/UpdateBudgetDistance', options).pipe(catchError(this.handleError));
  }

  public updateSystemCondition(systemId: number, newValue: string): Observable<Tuple> {
    const options = {
      params: new HttpParams().set('SystemId', systemId.toString()).set('NewValue', newValue)
    };
    return this._http.get<Tuple>('api/UCSystem/UpdateSystemCondition', options).pipe(catchError(this.handleError));
  }

  public getSystemLife(systemId: number): Observable<number> {
    const options = {
      params: new HttpParams().set('SystemId', systemId.toString())
    };
    return this._http.get<number>('api/UCSystem/GetSystemLife', options).pipe(catchError(this.handleError));
  }

  public getSystemDOC(systemId: number): Observable<number> {
    const options = {
      params: new HttpParams().set('SystemId', systemId.toString())
    };
    return this._http.get<number>('api/UCSystem/GetSystemDOC', options).pipe(catchError(this.handleError));
  }
  public addRecommendationFromEquipment(recommendation: AddRecommendationVM): Observable<Tuple3> {
    return this._http.post<Tuple3>('api/interpretation/AddRecommendationFromEquipment', recommendation).pipe(catchError(this.handleError));
  }

  public GetForecastPreference(inspectionId: number): Observable<any> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString())
    };
    return this._http.get('api/interpretation/GetInspectionForecastPrefrence', options).pipe(catchError(this.handleError));
  }

  public CreateLinkForDuplicateInspection(data: CopyInspection): Observable<CopyInspectionResponse> {
    return this._http.post<CopyInspectionResponse>('api/interpretation/CopyInspection', data).pipe(catchError(this.handleError));
  }

  public UpdateLinkForDuplicateInspection(data: CopyInspection): Observable<CopyInspectionResponse> {
    return this._http.post<CopyInspectionResponse>('api/interpretation/UpdateInspection', data).pipe(catchError(this.handleError));
  }

  public CheckInspection(inspectionId: number): Observable<boolean> {
    const options = {
      params: new HttpParams().set('InspectionId', inspectionId.toString())
    };
    return this._http.get<boolean>('api/interpretation/CheckForParentCopyInspection', options).pipe(catchError(this.handleError));
  }
  public ParentsChildEquipment(inspectionId: number): Observable<ParentInspectionResponse> {

    const options = {
      params: new HttpParams().set('InspectionId', inspectionId.toString())
    };
    return this._http.get<ParentInspectionResponse>('api/interpretation/ParentsChildEquipment', options).pipe(catchError(this.handleError));

  }
  public ChildsParentEquipment(inspectionId: number): Observable<ParentInspectionResponse> {
    const options = {
      params: new HttpParams().set('InspectionId', inspectionId.toString())
    };
    return this._http.get<ParentInspectionResponse>('api/interpretation/ChildsParentEquipment', options).pipe(catchError(this.handleError));

  }

  public RemoveLink(inspectionId: number): Observable<ParentInspectionResponse> {
    const options = {
      params: new HttpParams().set('InspectionId', inspectionId.toString())
    };
    return this._http.get<ParentInspectionResponse>('api/interpretation/RemoveLink', options).pipe(catchError(this.handleError));
  }

  public GetActionRecommentdationBySmuDate(equipmentId: number, smu: number, date: string): Observable<ActionRecommentDationOnDateVM> {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString()).set('smu', smu.toString()).set('date', date.toString())
    };
    return this._http.get<ActionRecommentDationOnDateVM>('api/UCPlanner/GetActionRecommentdationBySmuDate', options).pipe(catchError(this.handleError));
  }

  public DeleteRecommendation(QuoteDetailId: number): Observable<number> {
    const options = {
      params: new HttpParams().set('QuoteDetailId', QuoteDetailId.toString())
    };
    return this._http.get<number>('api/UCPlanner/DeleteRecommendation', options).pipe(catchError(this.handleError));
  }

  public getComponentmages(equipmentId: number, comparttypeId: number, side: number, pos: number): Observable<ComponentImagesResponse> {
    const options = {
      params: new HttpParams()
        .set('EquipmentId', equipmentId.toString())
        .set('CompartTypeId', comparttypeId.toString())
        .set('position', pos.toString())
        .set('side', side.toString())
    };
    return this._http.get<ComponentImagesResponse>('api/Interpretation/GetInspectionComponentImages', options).pipe(catchError(this.handleError));
  }

  GetForecastConfiguaration(customerId: number, jobsiteid: number, makeid: number, modelid: number, UnitNumber: string) {

    const model = new ForecastConfigurationVM();
    model.CustomerId = customerId;
    model.JobsiteId = jobsiteid;
    model.MakeId = makeid;
    model.ModelId = modelid;
    model.UnitNumber = UnitNumber;
    return this._http.post<ForecastWearConfigurationViewModel[]>('api/ForecastConfiguration/GetForecastConfiguration', model).pipe(catchError(this.handleError));
  }

  SaveForecastConfiguaration(customerId: number, jobsiteid: number, makeid: number, modelid: number, UnitNumber: string, WearId: number) {

    const model = new ForecastConfigurationVM();
    model.CustomerId = customerId;
    model.JobsiteId = jobsiteid;
    model.MakeId = makeid;
    model.ModelId = modelid;
    model.UnitNumber = UnitNumber;
    if (WearId > 0) {
      model.WearId = WearId;
    }
    return this._http.post<number>('api/ForecastConfiguration/SaveForecastConfiguration', model).pipe(catchError(this.handleError));
  }

  SaveForecastComponentConfiguaration(wearid: number, compartid: number, comparttype: number, position: number) {
    const model = new ForecastWearConfigurationComponentViewModel();
    model.WearRateId = wearid;
    model.CompartId = compartid;
    model.CompartTypeID = comparttype;
    model.Position = position;
    return this._http.post<number>('api/ForecastConfiguration/SaveForecastComponentConfiguration', model).pipe(catchError(this.handleError));
  }

  public GetForecastComponentData(wearId: number): Observable<ForecastingComponentWearRateGroupViewModel[]> {
    const options = {
      params: new HttpParams()
        .set('Wearid', wearId.toString())
    };
    return this._http.get<ForecastingComponentWearRateGroupViewModel[]>('api/ForecastConfiguration/GetForecastConfigurationComponent', options).pipe(catchError(this.handleError));
  }

  UpdateAvgCMUDoc(wearid: number, Id: number, Value: number, Flag: number) {
    const model = new UpdateAvgCmu();
    model.WearId = wearid;
    model.Id = Id;
    model.Value = Value;
    model.Flag = Flag;
    return this._http.post<number>('api/ForecastConfiguration/UpdateAvgCMUDoc', model).pipe(catchError(this.handleError));
  }

  public CheckForUnitNumber(unitno: string): Observable<any> {
    const options = {
      params: new HttpParams().set('UnitNo', unitno.toString())
    };
    return this._http.get('api/ForecastConfiguration/CheckForUnitNumber', options).pipe(catchError(this.handleError));
  }


  public GetUnitNo(jobsiteid: number, makeid: number, customerid: number, ModelId: number): Observable<UnitNumberVm[]> {
    const options = {
      params: new HttpParams().set('JobsiteId', jobsiteid.toString())
        .set('MakeId', makeid.toString())
        .set('BasemodeId', ModelId.toString())
        .set('CustomerId', customerid.toString())
    };
    return this._http.get<UnitNumberVm[]>('api/ForecastConfiguration/GetUnitNo', options).pipe(catchError(this.handleError));
  }


  public deleteBogieShimImage(photoId: number): Observable<boolean> {
    const options = {
      params: new HttpParams().set('photoId', photoId.toString())
    };
    return this._http.delete<boolean>('api/Interpretation/DeleteBogieShimImage', options).pipe(catchError(this.handleError));
  }

  public updateBogieShimPhoto(photo: BogieImageVM): Observable<Tuple> {
    return this._http.post<Tuple>('api/interpretation/UpdateBogieShimImage', photo).pipe(catchError(this.handleError));
  }

  public updateBogieComment(comment: BogieCommentVM): Observable<Tuple> {
    return this._http.post<Tuple>('api/interpretation/UpdateBogieComment', comment).pipe(catchError(this.handleError));
  }

  public addOrUpdateWorkOrder(data: AddUpdateWorkOrder): Observable<Tuple> {
    return this._http
      .post<Tuple>('api/interpretation/UpdateWorkOrder', data)
      .pipe(catchError(this.handleError));
  }

  public manageInterpretationAddiInspector(mod: AddiInspectorsOverviewModel): Observable<AddiInspectorsOverviewModel[]> {
    return this._http.post<AddiInspectorsOverviewModel[]>('api/interpretation/InspectionAdditionalInsspectors', mod).pipe(catchError(this.handleError));
  }

  public getBase64Image(url: string): Observable<string> {
    const options = {
      params: new HttpParams().set('Url', url.toString())
    };
    return this._http.get<string>('api/interpretation/GetBase64Image', options).pipe(catchError(this.handleError));
  }

  public AddSystemInspectionImages(photo: SystemInspectionImagesModel): Observable<boolean> {
    return this._http.post<boolean>('api/inspection/AddSystemInspectionImages', photo).pipe(catchError(this.handleError));
  }

  public GetInspectionObservationListPhoto(inspectionObId: number, PhotoId: number): Observable<string> {
    const options = {
      params: new HttpParams().set('inspectionObId', inspectionObId.toString()).set('PhotoId', PhotoId.toString())
    };
    return this._http.get<string>('api/inspection/GetInspectionObservationListPhoto', options).pipe(catchError(this.handleError));
  }

  public DeleteSystemInspectionImages(PhotoId: number) {
    const options = {
      params: new HttpParams().set('imageId', PhotoId.toString())
    };
    return this._http.get('api/inspection/DeleteSystemInspectionImages', options).pipe(catchError(this.handleError));
  }

  public updateSystemImages(image: ImageVM): Observable<BogieImageModel> {
    return this._http.post<BogieImageModel>('api/inspection/updateSystemInInventoryImage', image).pipe(catchError(this.handleError));
  }

  public getSystemHistoricalImages(equipmentId: number, systemType: number, side: number): Observable<ComponentImagesResponse> {
    const options = {
      params: new HttpParams()
        .set('EquipmentId', equipmentId.toString())
        .set('systemType', systemType.toString())
        .set('side', side.toString())

    };
    return this._http.get<ComponentImagesResponse>('api/Inspection/GetHistoricalImagesForSystem', options).pipe(catchError(this.handleError));
  }

  public UpdateSystemComment(systemId: number, newComment: string, inspectionId: number) {
    const options = {
      params: new HttpParams().set('systemId', systemId.toString()).set('comment', newComment).set('inspectionId', inspectionId)
    };
    return this._http.get('api/interpretation/SaveUpdateSystemComment', options).pipe(catchError(this.handleError));
  }

  getSeasonalDates(customerId: number, jobSiteId: number): Observable<ForecastSeason[]> {

    return this._http.get<ForecastSeason[]>(
      `api/Forecast/GetForecastSeasonalDates?customerId=${customerId}&jobSiteId=${jobSiteId}`);
  }

  SaveSeasonalDates(request: ForecastSeasonSaveRequest): Observable<any> {
    return this._http.post('api/Forecast/SaveSeasonalDates', request);
  }
  resetSeasonDate(weatherTypeId: number, customerId: number, jobsiteId:number): Observable<any> {
    return this._http.delete(`api/Forecast/ResetSeasonDate?weatherTypeId=${weatherTypeId}&CustomerId=${customerId}&JobsiteId=${jobsiteId}`
    );
  }


  updateEqualiserBar(model: EqualiserBarMeasurementUpdateModel ): Observable<boolean> {
    return this._http.post<boolean>(`api/Interpretation/UpdateEqualierBarValues`, model).pipe(catchError(this.handleError));
  }

  public addEqBarPhotoPath(photo: AddComponentPhotoModel): Observable<BogieImageModel> {
    return this._http.post<BogieImageModel>('api/inspection/AddEqBarPhotoPath', photo).pipe(catchError(this.handleError));
  }

  public EqBarInspPhoto(photo: AddComponentPhotoModel): Observable<Tuple> {
    return this._http.post<Tuple>('api/interpretation/EqBarInspPhoto', photo).pipe(catchError(this.handleError));
  }

  public deleteEqBarInspPhoto(inspectionId: number, photoId: number): Observable<Tuple> {
    const options = {
      params: new HttpParams()
        .set('InspectionId', inspectionId.toString())
        .set('PhotoId', photoId.toString())
    };
    return this._http.delete<Tuple>('api/interpretation/DeleteEqBarImage', options).pipe(catchError(this.handleError));
  }

  public updateEqBarInspPhoto(photo: AddThermalPhotoModel): Observable<Tuple3> {
    return this._http.post<Tuple3>('api/interpretation/UpdateEqBarImage', photo).pipe(catchError(this.handleError));
  }

  getEqBarImagesHistory(inspectionId: number, equipmentId: number) {
    const params = new HttpParams()
      .set('InspectionId', inspectionId.toString())
      .set('EquipmentId', equipmentId.toString());
    return this._http.get<ComponentImagesHistory[]>('api/interpretation/GetEqBarImagesHistory',{ params });
  }

  updateInspectionLocation(inspectionAuto: number, locationId: number) {
    const request = {
      InspectionAuto: inspectionAuto,
      LocationId: locationId
    };

    return this._http.post<boolean>('api/interpretation/UpdateInspectionLocation', request);
  }

  getInspectionLocations() {
    return this._http.get<InspectionLocationVM[]>('api/interpretation/GetInspectionLocations');
  }

}
